import React from 'react';
import { useAbility } from '@casl/react';
import Icon from '../Icons';
import { AbilityContext } from '../../config/abilityContext';
import BasicDropdown from '../Utils/Dropdown/BasicDropdown';

const ShiftMassiveActions = ({ handleClick, disabled, model }) => {
  const ability = useAbility(AbilityContext);

  const actions = () => {
    const authorizedActions = [];
    if (ability.can('destroy', model)) {
      authorizedActions.push({
        icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'destroy',
        props: {
          onClick: () => handleClick('massive_destroy'),
          disabled
        },
        title: 'Eliminar'
      });
    }

    if (ability.can('deactivate', model)) {
      authorizedActions.push({
        icon: <Icon icon="archive" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'massive_deactivate',
        props: {
          onClick: () => handleClick('massive_deactivate'),
          disabled
        },
        title: 'Desactivar'
      });
    }

    if (ability.can('deactivate', model)) {
      authorizedActions.push({
        icon: <Icon icon="archive" height="16px" width="16px" style={{ marginRight: 5 }} />,
        key: 'massive_active',
        props: {
          onClick: () => handleClick('massive_active'),
          disabled
        },
        title: 'Activar'
      });
    }
    return authorizedActions;
  };

  return (
    <div className="mb-4">
      <BasicDropdown
        block
        items={actions()}
        noArrow
        right
        titleDrop={
          <span className="align-middle">
            Acciones Masivas <Icon icon="ellipsis-vertical" height="20px" width="20px" />
          </span>
        }
        variant="outline-primary"
      />
    </div>
  );
};

export default ShiftMassiveActions;
